// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emotion-list {
    width: 100%;
    font-size: 12px;
}


/* =========================================
   En-tête
   ========================================= */

.emotion-list-header {
    display: flex;
    align-items: center;

    width: 100%;
    height: 26px;

    box-sizing: border-box;
    gap: 2px;
}


/* espace réservé à l'image */
.emotion-header-image {
    flex: 0 0 24px;
}


/* Emotions */
.emotion-header-emotion {
    flex: 1 1;
    min-width: 0;
    color: #808080;
    text-align: center;
}


/* Intensité */
.emotion-header-intensity {
    flex: 1 1;
    min-width: 0;
    color: #808080;
    text-align: center;
}


/* Sentiment */
.emotion-header-sentiment {
    flex: 1 1;
    min-width: 0;
    color: #808080;
    text-align: center;
}


/* Confiance */
.emotion-header-confidence {
    flex: 0 0 35px;
    color: #808080;
    text-align: center;
}


/* espace réservé au bouton X */
.emotion-header-delete {
    flex: 0 0 24px;
}


.emotion-line {
    display: flex;
    align-items: center;

    width: 100%;
    height: 32px;

    box-sizing: border-box;
    gap: 2px;
}


/* Image : largeur fixe */
.emotion-line-image {
    flex: 0 0 24px;

    width: 24px;
    height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;
}

.emotion-line-image img {
    width: 22px;
    height: 22px;
    object-fit: contain;
}


/* Emotion : prend 2 parts */
.emotion-line-emotion {
    flex: 1.2 1;
    min-width: 0;
}

.emotion-line-emotion select {
    width: 100%;
    height: 28px;
    box-sizing: border-box;

    background: #202020;
    color: #eeeeee;

    border: 1px solid #888888;

    padding-left: 4px;
    font-size: 11px;
}


/* Intensité / Sentiment */
.emotion-line-value {
    flex: 1 1;
    min-width: 0;

    display: flex;
    align-items: left;

    gap: 3px;
}

.emotion-line-value input[type="range"] {
    flex: 1 1;

    width: 100%;
    min-width: 0;
}

.emotion-line-value span {
    flex: 0 0 25px;

    width: 25px;

    text-align: left;
    font-size: 11px;
}


/* Confiance */
.emotion-line-confidence {
    flex: 0 0 35px;

    width: 35px;

    text-align: center;
    font-size: 11px;
}


/* Suppression */
.emotion-line-delete {
    flex: 0 0 24px;

    width: 24px;
    height: 28px;

    padding: 0;
    border: none;
    background: transparent;

    color: red;

    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
}

.emotion-line-delete:hover {
    color: #ff6060;
}


/* =========================================
   Ajout
   ========================================= */

.emotion-list-add {
    width: 100%;
    height: 28px;

    margin-top: 3px;

    border: none;
    background: transparent;

    color: #9292ff;

    font-size: 22px;
    line-height: 24px;

    cursor: pointer;
}


.emotion-list-add:hover {
    background: rgba(146, 146, 255, 0.10);
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/emotionlist.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA,6BAA6B;AAC7B;IACI,cAAc;AAClB;;;AAGA,aAAa;AACb;IACI,SAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;;AAGA,cAAc;AACd;IACI,SAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;;AAGA,cAAc;AACd;IACI,SAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;;AAGA,cAAc;AACd;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;;AAGA,+BAA+B;AAC/B;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA,yBAAyB;AACzB;IACI,cAAc;;IAEd,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;;AAGA,4BAA4B;AAC5B;IACI,WAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;;IAEtB,mBAAmB;IACnB,cAAc;;IAEd,yBAAyB;;IAEzB,iBAAiB;IACjB,eAAe;AACnB;;;AAGA,0BAA0B;AAC1B;IACI,SAAW;IACX,YAAY;;IAEZ,aAAa;IACb,iBAAiB;;IAEjB,QAAQ;AACZ;;AAEA;IACI,SAAW;;IAEX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;;IAEd,WAAW;;IAEX,gBAAgB;IAChB,eAAe;AACnB;;;AAGA,cAAc;AACd;IACI,cAAc;;IAEd,WAAW;;IAEX,kBAAkB;IAClB,eAAe;AACnB;;;AAGA,gBAAgB;AAChB;IACI,cAAc;;IAEd,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,YAAY;IACZ,uBAAuB;;IAEvB,UAAU;;IAEV,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;;AAGA;;8CAE8C;;AAE9C;IACI,WAAW;IACX,YAAY;;IAEZ,eAAe;;IAEf,YAAY;IACZ,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;IACf,iBAAiB;;IAEjB,eAAe;AACnB;;;AAGA;IACI,qCAAqC;AACzC","sourcesContent":[".emotion-list {\n    width: 100%;\n    font-size: 12px;\n}\n\n\n/* =========================================\n   En-tête\n   ========================================= */\n\n.emotion-list-header {\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    height: 26px;\n\n    box-sizing: border-box;\n    gap: 2px;\n}\n\n\n/* espace réservé à l'image */\n.emotion-header-image {\n    flex: 0 0 24px;\n}\n\n\n/* Emotions */\n.emotion-header-emotion {\n    flex: 1 1 0;\n    min-width: 0;\n    color: #808080;\n    text-align: center;\n}\n\n\n/* Intensité */\n.emotion-header-intensity {\n    flex: 1 1 0;\n    min-width: 0;\n    color: #808080;\n    text-align: center;\n}\n\n\n/* Sentiment */\n.emotion-header-sentiment {\n    flex: 1 1 0;\n    min-width: 0;\n    color: #808080;\n    text-align: center;\n}\n\n\n/* Confiance */\n.emotion-header-confidence {\n    flex: 0 0 35px;\n    color: #808080;\n    text-align: center;\n}\n\n\n/* espace réservé au bouton X */\n.emotion-header-delete {\n    flex: 0 0 24px;\n}\n\n\n.emotion-line {\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    height: 32px;\n\n    box-sizing: border-box;\n    gap: 2px;\n}\n\n\n/* Image : largeur fixe */\n.emotion-line-image {\n    flex: 0 0 24px;\n\n    width: 24px;\n    height: 24px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.emotion-line-image img {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n}\n\n\n/* Emotion : prend 2 parts */\n.emotion-line-emotion {\n    flex: 1.2 1 0;\n    min-width: 0;\n}\n\n.emotion-line-emotion select {\n    width: 100%;\n    height: 28px;\n    box-sizing: border-box;\n\n    background: #202020;\n    color: #eeeeee;\n\n    border: 1px solid #888888;\n\n    padding-left: 4px;\n    font-size: 11px;\n}\n\n\n/* Intensité / Sentiment */\n.emotion-line-value {\n    flex: 1 1 0;\n    min-width: 0;\n\n    display: flex;\n    align-items: left;\n\n    gap: 3px;\n}\n\n.emotion-line-value input[type=\"range\"] {\n    flex: 1 1 0;\n\n    width: 100%;\n    min-width: 0;\n}\n\n.emotion-line-value span {\n    flex: 0 0 25px;\n\n    width: 25px;\n\n    text-align: left;\n    font-size: 11px;\n}\n\n\n/* Confiance */\n.emotion-line-confidence {\n    flex: 0 0 35px;\n\n    width: 35px;\n\n    text-align: center;\n    font-size: 11px;\n}\n\n\n/* Suppression */\n.emotion-line-delete {\n    flex: 0 0 24px;\n\n    width: 24px;\n    height: 28px;\n\n    padding: 0;\n    border: none;\n    background: transparent;\n\n    color: red;\n\n    font-size: 22px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.emotion-line-delete:hover {\n    color: #ff6060;\n}\n\n\n/* =========================================\n   Ajout\n   ========================================= */\n\n.emotion-list-add {\n    width: 100%;\n    height: 28px;\n\n    margin-top: 3px;\n\n    border: none;\n    background: transparent;\n\n    color: #9292ff;\n\n    font-size: 22px;\n    line-height: 24px;\n\n    cursor: pointer;\n}\n\n\n.emotion-list-add:hover {\n    background: rgba(146, 146, 255, 0.10);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
